module.exports = __webpack_public_path__ + "assets/img/tx11_1.6f74a7ed.jpg";